export default __webpack_public_path__ + "static/media/background-chase-light.46b2d1c4.png";